import useBlogs from "hooks/useBlogs";
import SourceFlowImage from "@sourceflow-uk/sourceflowimage";
import { Card, Col, Container, Row } from "reactstrap";
import styles from "./styles.module.scss";
import Arrow from "../../public/site-assets/svg/arrow.svg";

import { Autoplay, Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import "swiper/css";
import "swiper/css/autoplay";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const LatestSuccessStory = ({
  className,
  content,
  buttons,
  swiperID,
  limit,
  filterTags,
  filterRegion,
  locale,
  sectionId,
}) => {
  const post = useBlogs({
    limit: limit,
    tagFilters: filterTags,
    countryFilters: filterRegion,
  });
  const settings = {
    modules: [Navigation, Pagination, Autoplay],
    loop: true,
    spaceBetween: 30,
    slidesPerView: 1,
    speed: 500,
    autoplay: {
      delay: 5000,
    },
    pagination: {
      clickable: true,
      el: `.${swiperID}.swiper-custom-paginations`,
    },
    navigation: {
      nextEl: `.${swiperID}.swiper-next`,
      prevEl: `.${swiperID}.swiper-prev`,
    },
    // breakpoints: {
    //     1200: {
    //         slidesPerView: 3,
    //     },
    //     767: {
    //         slidesPerView: 2,
    //     },

    // }
  };
  return (
    post?.length >= 1 && (
      <section
        id={sectionId}
        className={`${styles.root} ${className} position-relative`}
      >
        <Container>
          <div className={`heading text-md-center mb-5 position-relative`}>
            {content ? (
              <div dangerouslySetInnerHTML={{ __html: content }} />
            ) : (
              ""
            )}
            <div className="d-flex mb-4 position-absolute arrows-wrapper">
              <button
                className={`${swiperID} arrow swiper-prev border-0`}
                aria-label="Prev"
              >
                <Arrow />
              </button>
              <button
                className={`${swiperID} arrow swiper-next border-0 ms-2`}
                aria-label="Next"
              >
                <Arrow />
              </button>
            </div>
          </div>
          <Swiper {...settings} className="position-relative pb-5 pb-md-0">
            {post?.map((post, index) => (
              <SwiperSlide key={index}>
                <Card className="border-0 h-100 bg-transparent h-100 d-block">
                  <Row className="h-100">
                    <Col md={4} className="mb-5 mb-md-0">
                      <SourceFlowImage
                          src={post?.image ? post.image : "/site-assets/placeholders/img-placeholder.jpg"}
                          size="600x400"
                          alt={post?.title}
                          className="card-img rounded-0 h-100"
                      />
                    </Col>
                    <Col md={8} className="pt-md-5 pb-5 ps-md-5">
                      <p className="fs-4">
                        <strong>{post.title}</strong>
                      </p>
                      {post?.short_description ? (
                        <div
                          className="mt-2"
                          dangerouslySetInnerHTML={{
                            __html: post?.short_description,
                          }}
                        />
                      ) : (
                        ""
                      )}
                      <div className="mt-5 d-flex flex-wrap flex-md-nowrap justify-content-between align-items-center flex-column-reverse flex-md-row">
                        <div className="d-flex flex-wrap gap-3">
                          <a
                            href={`${locale}/blog/${post.url_slug}`}
                            className="primaryBtn no-arrow text-nowrap m-0y"
                          >
                            Read the full story
                          </a>

                          {buttons?.length > 0 && (
                            <div className="mt-3 d-flex gap-2 flex-wrap">
                              {buttons.map(({ id, url, label, className }) => (
                                <a key={id} href={url} className={className}>
                                  {label}
                                </a>
                              ))}
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Card>
              </SwiperSlide>
            ))}
            <div
              className={`${swiperID} swiper-custom-paginations position-absolute`}
            />
          </Swiper>
          <span className="position-absolute message-icon d-none d-md-inline-block">
            <img src={"/site-assets/svg/message.svg"} alt="Message Icon" />
          </span>
        </Container>
      </section>
    )
  );
};

export default LatestSuccessStory;
